export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_04.2c513955.jpg";